import React from 'react'
import { FormInstance, Upload, UploadFile, UploadProps, message } from 'antd'
import { InboxOutlined } from '@ant-design/icons'
import type { UploadRequestOption } from 'rc-upload/lib/interface'
import styled from 'styled-components'
import { uploadFileToGCS } from '../../service/gcs-upload.service'

const { Dragger } = Upload

interface InputDragUploadImgProps {
    form: FormInstance
    name: string | (string | number)[]
    initialValue?: string
    aspectRatioRecomment: string
    sizeRecomment: string
}

const DraggerInput = styled(Dragger)`
    span.ant-upload.ant-upload-btn {
        padding: 0;
    }
    div.ant-upload-drag-container {
        width: 100%;
        height: 222px;
    }
`

const InputDragUploadImg: React.FC<InputDragUploadImgProps> = ({
    form,
    name,
    initialValue,
    aspectRatioRecomment,
}) => {
    const [imageUrl, setImageUrl] = React.useState<string>('')
    const [fileList, setFileList] = React.useState<UploadFile[]>([])

    React.useEffect(() => {
        if (initialValue) {
            const urlSegments = initialValue.split('/')
            const lastSegment = urlSegments[urlSegments.length - 1]
            const fileName = lastSegment.split('?')[0]
            setImageUrl(initialValue)
            setFileList([{ url: initialValue, uid: '', name: fileName }])
        }
    }, [form, initialValue, name])

    const customRequest = async (options: UploadRequestOption) => {
        const { file, onProgress, onSuccess, onError } = options
        try {
            const result = await uploadFileToGCS(
                file as File,
                'image',
                (percent) => onProgress?.({ percent } as unknown as ProgressEvent)
            )
            setImageUrl(result.url)
            form.setFieldValue(name, result.url)
            message.success(`${(file as File).name} อัปโหลดไฟล์เสร็จสิ้น`)
            onSuccess?.(result)
        } catch (err) {
            message.error(
                `${(file as File).name} อัปโหลดไฟล์ล้มเหลว: ${(err as Error).message}`
            )
            onError?.(err as Error)
        }
    }

    const uploadProps: UploadProps = {
        name: 'image',
        multiple: false,
        accept: 'image/jpg, image/png, image/jpeg',
        maxCount: 1,
        fileList,
        customRequest,
        onChange: (info) => {
            setFileList(info.fileList)
        },
        onPreview: async (file: UploadFile) => {
            window.open(file.url || file.response?.url, '_blank')
        },
        onRemove: () => {
            form.setFieldValue(name, undefined)
        },
    }

    return (
        <DraggerInput maxCount={1} {...uploadProps}>
            {fileList.length === 0 ? (
                <div style={{ padding: 16 }}>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">เลือกไฟล์หรือลากมาที่นี่</p>
                    <p className="ant-upload-hint">
                        อัตราส่วนที่แนะนำคือ {`${aspectRatioRecomment} `}
                        <br />
                        รองรับการอัปโหลดไฟล์ PNG, JPG, JPEG ครั้งละ 1
                        รูปภาพเท่านั้น
                    </p>
                </div>
            ) : (
                <img
                    src={imageUrl}
                    alt="Preview"
                    style={{ height: '216px', margin: '12px' }}
                />
            )}
        </DraggerInput>
    )
}

export default InputDragUploadImg
